/**
 * `/studio/clients/new` — the onboarding wizard.
 *
 * `?step=` so a half-finished wizard is a link and the back button works.
 * `.docs/20` §B: "the wizard is a sequence, not a transaction" — every step is one
 * action that has already committed, so leaving is safe and coming back is a URL.
 *
 * Which is exactly why `routeSearch`: a link to a step whose name has since changed
 * belongs on the first step, not on an error page halfway through onboarding.
 */

import { createFileRoute } from '@tanstack/react-router'

import {
  OnboardingPage,
  OnboardingSearchSchema,
} from '../../../pages/studio/onboarding/OnboardingPage.js'
import { routeSearch } from '../../../search/useSearchState.js'

export const Route = createFileRoute('/studio/clients/new')({
  validateSearch: routeSearch(OnboardingSearchSchema),
  component: OnboardingPage,
})
